import { AuthListUsersMasterResponse } from '@core/models/responses/auth/auth-list-users-master-response';
import { AuthService } from '@core/services/auth/auth.service';
import { ModalService } from '@core/services/modal/modal.service';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { DxDataGridModule } from 'devextreme-angular';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-modal-suporte-usuario',
  standalone: true,
  imports: [
    ModalComponent,
    DxDataGridModule,
    FormsModule,
    InputText,
    ReactiveFormsModule,
    Button
  ],
  templateUrl: './modal-suporte-usuario.component.html',
  styleUrl: './modal-suporte-usuario.component.scss'
})
export class ModalSuporteUsuarioComponent implements OnInit, OnDestroy {
  open = false;
  dataSource: AuthListUsersMasterResponse[] = [];
  form: FormGroup;
  columns: any[] = [
    {
      dataField: 'nome',
      caption: 'NOME DO USUÁRIO',
      alignment: 'left'
    },
    {
      dataField: 'login',
      caption: 'LOGIN',
      alignment: 'left'
    },
    {
      dataField: 'grupoUsuario',
      caption: 'GRUPO DE USUÁRIO',
      alignment: 'left'
    },
    {
      caption: '',
      cellTemplate: 'buttonsTemplate',
      alignment: 'center'
    }
  ];
  fb = inject(FormBuilder);
  messageService = inject(MessageService);
  authService = inject(AuthService);
  destroy$ = new Subject<void>();
  modalService = inject(ModalService);
  readonly MODAL_ASSUMIR_PERFIL_USUARIO = 'MODAL_ASSUMIR_PERFIL_USUARIO';
  closabe: boolean;

  ngOnInit() {
    this.listenModal();
    this.createForm();
  }

  listenModal() {
    this.modalService
      .listenChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ open, name, data }) => {
        if (open && name === this.MODAL_ASSUMIR_PERFIL_USUARIO) {
          this.open = open;
          this.closabe = data?.closabe;
        }
      });
  }

  createForm() {
    this.form = this.fb.group(
      {
        idUsuario: [null],
        login: [null],
        email: [null]
      },
      { validators: this.validation() }
    );
  }

  validation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const { idUsuario, login, email } = control.value;

      const filledFields = [idUsuario, login, email].filter(
        value => !!value
      ).length;

      return filledFields === 1 ? null : { onlyOneRequired: true };
    };
  }

  search() {
    this.dataSource = [];
    if (this.form.valid) {
      this.authService
        .listMasterUsers(this.form.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          this.dataSource = res?.dados;
          if (!res?.dados.length) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Alerta',
              detail: 'Nenhum usuário encontrado!',
              key: 'global-toast'
            });
          }
        });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Alerta',
        detail: 'Preencha apenas um dos campos para realizar a busca',
        key: 'global-toast'
      });
    }
  }

  assumirPerfil(data: AuthListUsersMasterResponse) {
    const idUsuarioMaster:number = this.getLoginMaster();
    this.authService
      .assumeProfile(data.login, idUsuarioMaster)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: `Perfil do usuário ${res?.nome} carregado com sucesso!`,
            key: 'global-toast'
          });
          this.close();
        }
      });
  }

  getLoginMaster(): number {
    const master = this.dataSource.find(usuario => {
      return usuario.grupoUsuario.toLowerCase().includes('master');
    });
    return master?.idMaster ?? 0;
  }

  close() {
    this.form.reset();
    this.dataSource = [];
    this.open = false;
    this.closabe = false;
    this.modalService.clear();
  }

  ngOnDestroy() {
    this.close();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
